import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, gamesCasino, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the view for table categories products.
 * @extends JetView
 */
export default class tableCategoriesProductsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam('partner', true); // Getting partner ID from parameters
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('categoriesProductsEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 55, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Categorie', // Column ID
                                    header: _('Categoría'), // Localized column header
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Product', // Column ID
                                    header: _('Productos'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Order', // Column ID
                                    header: _('Orden'), // Localized column header
                                    width: 70, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Partner'), // Localized column header
                                    width: 70, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    // Edit button click event
                                    $$('editwinCategoriesProduct').show(); // Show edit window
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // Data source URL
                            url:
                                devConfig.geturlApi() +
                                'Categories-products/GetCategoriesProducts?Partner=' +
                                id_partner +
                                '',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Getting partner ID from parameters
        grid = $$('datatable'); // Reference to the datatable
        var url = grid.data.url; // Data source URL
        var filter = ''; // Filter string
        var optionsCategorias = []; // Options for categories
        var popup = webix.ui({
            // Popup window for editing categories
            view: 'window',
            id: 'editwinCategoriesProduct', // ID for the edit window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 680 : 430, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Editar Categorias Productos') }, // Label for the header
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Close button click event
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for editing categories
                    id: 'editform', // ID for the edit form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 680 : 380, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelWidth: 90, // Label width
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'text', // Text input for Category
                            label: _('Categoría'),
                            name: 'Categorie',
                            readonly: true, // Read-only field
                            labelWidth: 90, // Label width
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'text', // Text input for Product
                            label: _('Producto'),
                            name: 'Product',
                            readonly: true, // Read-only field
                            labelWidth: 90, // Label width
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo', // Combo box for IsActivate
                            label: _('Estado'),
                            name: 'IsActivate',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelWidth: 90, // Label width
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'text', // Text input for Order
                            label: _('Orden'),
                            name: 'Order',
                            type: 'number', // Input type
                            readonly: false, // Editable field
                            labelWidth: 90, // Label width
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            margin: 10, // Margin for the next element
                            cols: [
                                {
                                    view: 'text', // Text input for Note
                                    labelPosition: 'top', // Label position
                                    label: _('Explicación'),
                                    name: 'Note',
                                    labelWidth: 160, // Label width
                                    attributes: { type: 'text' }, // Input attributes
                                },
                            ],
                        },
                        {
                            cols: [
                                // Buttons for Cancel and Save
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        // Cancel button click event
                                        this.getTopParentView().hide(); // Hide the window
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        // Save button click event
                                        var values = $$('editform').getValues(); // Get form values
                                        values.Partner = id_partner; // Add partner ID to values
                                        webix
                                            .ajax() // AJAX request to save changes
                                            .headers({
                                                'Content-type': 'application/json', // Content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Categories/UpdateCategoryProduct',
                                                '{"Id":' +
                                                    values.Id +
                                                    ',"IsActivate":"' +
                                                    values.IsActivate +
                                                    '","Order":"' +
                                                    values.Order +
                                                    '","Partner":"' +
                                                    values.Partner +
                                                    '","Note":"' +
                                                    values.Note +
                                                    '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Categoría Producto Editada', // Success message
                                                        );
                                                        grid.clearAll(); // Clear the grid
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload the grid data
                                                        );
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Hide the window
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var vthis = this; // Reference to the current instance
        this.on(this.app, 'categoriesProducts:filter', (filterData) => {
            // Event handler for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to filter string
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Reload the grid data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.refreshColumns(); // Refresh columns after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Reload grid data with sorting
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event handler for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load grid data for selected player
            );
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
        webix
            .ajax() // AJAX request to get categories
            .headers({
                'Content-type': 'application/json', // Content type
            })
            .post(devConfig.geturlApi() + 'Categories/GetCategories', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    for (var i = 0; i < resp.data.length; i++) {
                        // Iterate through categories
                        resp.data[i].id = resp.data[i].Id; // Map ID
                        resp.data[i].value = resp.data[i].Description; // Map description
                    }
                    optionsCategorias = resp.data; // Store categories options
                    var popupAdd = webix.ui({
                        // Popup window for adding categories
                        view: 'window',
                        id: 'AddCategoriesProduct', // ID for the add window
                        width: screen.width < 500 ? 350 : 450, // Width based on screen size
                        height: screen.width < 500 ? 600 : 300, // Height based on screen size
                        fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
                        head: {
                            view: 'toolbar', // Toolbar for the window header
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Agragar Categoría Producto'), // Label for the header
                                },
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    click: function () {
                                        // Close button click event
                                        this.getTopParentView().hide(); // Hide the window
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center position of the window
                        modal: true, // Modal window
                        body: {
                            view: 'scrollview', // Scrollable view
                            scroll: 'y', // Vertical scrolling
                            body: {
                                view: 'form', // Form for adding categories
                                id: 'addform', // ID for the add form
                                width: screen.width < 500 ? 350 : 450, // Width based on screen size
                                height: screen.width < 500 ? 600 : 250, // Height based on screen size
                                elements: [
                                    // Form elements
                                    {
                                        view: 'combo', // Combo box for Category
                                        label: _('Categoría'),
                                        name: 'Category',
                                        options: optionsCategorias, // Options for the combo box
                                        labelWidth: 90, // Label width
                                        labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                                    },
                                    {
                                        view: 'combo', // Combo box for Product
                                        label: _('Producto'),
                                        name: 'Product',
                                        options: gamesCasino, // Options for the combo box
                                        labelWidth: 90, // Label width
                                        labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                                    },
                                    {
                                        view: 'combo', // Combo box for IsActivate
                                        label: _('Estado'),
                                        name: 'IsActivate',
                                        options: [
                                            // Options for the combo box
                                            { id: 'A', value: _('Activado') },
                                            { id: 'I', value: _('Inactivado') },
                                        ],
                                        labelWidth: 90, // Label width
                                        labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                                    },
                                    {
                                        view: 'text', // Text input for Order
                                        label: _('Orden'),
                                        name: 'Order',
                                        type: 'number', // Input type
                                        labelWidth: 90, // Label width
                                        labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                                    },
                                    {
                                        cols: [
                                            // Buttons for Cancel and Save
                                            {
                                                view: 'button', // Cancel button
                                                value: _('Cancelar'),
                                                click: function () {
                                                    // Cancel button click event
                                                    this.getTopParentView().hide(); // Hide the window
                                                    $$('addform').setValues(
                                                        $$('addform').getCleanValues(), // Reset form values
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button', // Save button
                                                type: 'form',
                                                value: _('Guardar'),
                                                click: function ($e) {
                                                    // Save button click event
                                                    var values = $$('addform').getValues(); // Get form values
                                                    values.Partner = id_partner; // Add partner ID to values
                                                    webix
                                                        .ajax() // AJAX request to save new category
                                                        .headers({
                                                            'Content-type': 'application/json', // Content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Categories/SaveCategoryProduct',
                                                            '{"Category":"' +
                                                                values.Category +
                                                                '", "Product":"' +
                                                                values.Product +
                                                                '", "IsActivate":"' +
                                                                values.IsActivate +
                                                                '", "Order":"' +
                                                                values.Order +
                                                                '", "Partner":"' +
                                                                values.Partner +
                                                                '"}',
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Error! ', // Error message
                                                                    );
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Categoría Producto Agregada', // Success message
                                                                    );
                                                                    grid.clearAll(); // Clear the grid
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload the grid data
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    $$('addform').setValues(
                                                        $$('addform').getCleanValues(), // Reset form values
                                                    );
                                                    this.getTopParentView().hide(); // Hide the window
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                    });
                    vthis.on(vthis.app, 'addCategorieProduct:button', (filter) => {
                        popupAdd.show(); // Show add category popup
                    });
                },
            });
    }
}

// FILE DOCUMENTED
